import * as Logos from '@atlaskit/logo';
import { B300, DN10A, N0 } from '@atlaskit/theme/colors';
import { ProductKey } from '@atlassiansox/bxpkit-core';
import styled from '@emotion/styled';
import React from 'react';
import { ProductType } from '../../model';

export type PageHeaderLogoProps = {
  readonly productData: ProductType;
  readonly useDarkBackgroundMode: boolean;
};

export function PageHeaderLogo({
  productData,
  useDarkBackgroundMode
}: PageHeaderLogoProps) {
  const textColor = useDarkBackgroundMode ? DN10A : N0;
  const iconColor = useDarkBackgroundMode ? B300 : N0;
  const Logostyle = {
    iconColor,
    size: 'xlarge',
    textColor
  };

  // Try and get Atlaskit Logo from product data
  if (productData.atlasKitLogoName) {
    const allLogos = { ...Logos };
    const ProductLogoClass = allLogos[productData.atlasKitLogoName];
    if (!!ProductLogoClass) {
      return <ProductLogoClass key={productData.productKey} {...Logostyle} />;
    }
  }

  // for team central, get the logo from magnolia
  if (
    productData.productKey === ProductKey.TEAM_CENTRAL &&
    !!productData.productLogoWhiteUrl
  ) {
    return (
      <CMSLogo
        key={productData.productKey}
        src={productData.productLogoWhiteUrl}
      />
    );
  }

  switch (productData.productKey) {
    case 'com.atlassian.bitbucket':
      return (
        <Logos.BitbucketLogo key={productData.productKey} {...Logostyle} />
      );
    case 'confluence.ondemand':
      return (
        <Logos.ConfluenceLogo key={productData.productKey} {...Logostyle} />
      );
    case 'jira-core.ondemand':
      return (
        <Logos.JiraWorkManagementLogo
          key={productData.productKey}
          {...Logostyle}
        />
      );
    case 'jira-workmanagement.ondemand':
      return (
        <Logos.JiraWorkManagementLogo
          key={productData.productKey}
          {...Logostyle}
        />
      );
    case 'jira-servicedesk.ondemand':
      return (
        <Logos.JiraServiceManagementLogo
          key={productData.productKey}
          {...Logostyle}
        />
      );
    case 'jira-software.ondemand':
      return <Logos.JiraLogo key={productData.productKey} {...Logostyle} />;
    case 'opsgenie':
      return <Logos.OpsGenieLogo key={productData.productKey} {...Logostyle} />;
    case 'statuspage':
      return (
        <Logos.StatuspageLogo key={productData.productKey} {...Logostyle} />
      );
    case 'trello':
      return <Logos.TrelloLogo key={productData.productKey} {...Logostyle} />;
    default:
      return productData && productData.productName ? (
        <h2 style={{ color: textColor }}>{productData.productName}</h2>
      ) : (
        <Logos.AtlassianLogo key={productData.productKey} {...Logostyle} />
      );
  }
}

const CMSLogo = styled.img`
  height: 48px;
`;
